<template>
  <div>
    <contract-process-locked></contract-process-locked>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import ContractProcessLocked from './Components/ContractProcessLocked'

export default {
  components: {
    ContractProcessLocked,
  },
  async created () {
    const vm = this
    vm.pms ('SystemAdministrator', 'visible', 'r')
  }
};
</script>

<style >
</style>
